// Правила для расписания департаментов
const HuntingTicketsSchedule = () =>
  import(
    /* webpackChunkName: "Schedule" */ 'RootDir/modules/Administration/Schedule/HuntingTicketsSchedule.vue'
  );

// Производственный календарь
const ProductionCalendar = () =>
  import(
    /* webpackChunkName: "Schedule" */ 'RootDir/modules/Administration/ProductionCalendar/List.vue'
  );

// Системные пользователи
const SystemUsers = () =>
  import(
    /* webpackChunkName: "Schedule" */ 'RootDir/modules/Administration/SystemUsers/List.vue'
  );

// Сезоны охоты
const Seasons = () =>
  import(
    /* webpackChunkName: "Seasons" */ '@/modules/Administration/Seasons/List.vue'
    );

// Настройки сезонов
const SeasonConfigs = () =>
  import(
    /* webpackChunkName: "SeasonConfigs" */ '@/modules/Administration/SeasonConfigs/List.vue'
    );

// Подписки на события ГИС ГМП
const GisGmpSubscriptions = () =>
  import(
    /* webpackChunkName: "GisGmpSubscriptions" */ '@/modules/Administration/GisGmpSubscriptions/List.vue'
  );

export default [
  {
    path: 'schedule/hunting-tickets',
    name: 'hunting-tickets-schedule',
    component: HuntingTicketsSchedule,
  },
  {
    path: 'production-calendar',
    name: 'administration-production-calendar',
    component: ProductionCalendar,
  },
  {
    path: 'system-users',
    name: 'administration-system-users',
    component: SystemUsers,
  },
  {
    path: 'seasons',
    name: 'administration-seasons',
    component: Seasons,
  },
  {
    path: 'season-configs',
    name: 'administration-season-configs',
    component: SeasonConfigs,
  },
  {
    path: 'gis-gmp-subscriptions',
    name: 'administration-gis-gmp-subscriptions',
    component: GisGmpSubscriptions,
  },
];
